import * as React from 'react';
import * as style from './Layout.css';
import { mergeStyles } from '@cian/utils';

export interface ILayoutProps extends React.PropsWithChildren {
  fullwidth?: boolean;
  dataMark?: string;
  tag?: 'div' | 'section';
  // Anchor for Sticky Header scrolling
  id?: string;
  // Data-attribute that contains anchor and tab name
  'data-nav-tab'?: string;
}

export const Layout: React.FC<ILayoutProps> = props => {
  const { fullwidth = false, tag: Tag = 'section', dataMark = 'Layout', id } = props;

  return (
    <Tag
      data-nav-tab={props['data-nav-tab']}
      id={id}
      data-mark={dataMark}
      {...mergeStyles(fullwidth ? style['layout--fullwidth'] : style['layout'])}
    >
      {props.children}
    </Tag>
  );
};
